module.exports = __webpack_public_path__ + "img/cart-flatbed.83d68667.svg";